import { CompanyJoinRequestsManageContent } from "../../features/companyWorkspace";

function CompanyJoinRequestsManageScreen() {
  return <CompanyJoinRequestsManageContent />;
}

export default CompanyJoinRequestsManageScreen;
